export default {
      id: "inresize-usage",
      viewBox: "0 0 34 34",
      url: __webpack_public_path__ + "img/icons.deccda40.svg#inresize",
      toString: function () {
        return this.url;
      }
    }